import './PlanTabs.less';
export { default as PlanTabs } from './PlanTabs';
export { default } from './PlanTabs';